import { Directive, ElementRef, HostListener, inject } from '@angular/core';
@Directive({ selector: '[appTwoDigitDecimalNumber]' })
export class TwoDigitDecimaNumberDirective {
  private readonly el = inject(ElementRef);

  private readonly regex: RegExp = new RegExp(/^\d*\.?\d{0,2}$/g);
  private readonly specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', '-', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    let current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    const next: string = [current.slice(0, position), event.key == 'Decimal' ? '.' : event.key, current.slice(position)].join('');
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }
}